var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/notification"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0201 3.26953C8.71009 3.26953 6.02009 5.95953 6.02009 9.26953V12.1595C6.02009 12.7695 5.76009 13.6995 5.45009 14.2195L4.30009 16.1295C3.59009 17.3095 4.08009 18.6195 5.38009 19.0595C9.69009 20.4995 14.3401 20.4995 18.6501 19.0595C19.8601 18.6595 20.3901 17.2295 19.7301 16.1295L18.5801 14.2195C18.2801 13.6995 18.0201 12.7695 18.0201 12.1595V9.26953C18.0201 5.96953 15.3201 3.26953 12.0201 3.26953Z",
    stroke: "#9094A2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.8699 3.55883C13.5599 3.46883 13.2399 3.39883 12.9099 3.35883C11.9499 3.23883 11.0299 3.30883 10.1699 3.55883C10.4599 2.81883 11.1799 2.29883 12.0199 2.29883C12.8599 2.29883 13.5799 2.81883 13.8699 3.55883Z",
    stroke: "#9094A2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.02 19.4199C15.02 21.0699 13.67 22.4199 12.02 22.4199C11.2 22.4199 10.44 22.0799 9.90002 21.5399C9.36002 20.9999 9.02002 20.2399 9.02002 19.4199",
    stroke: "#9094A2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsBell);
export default __webpack_public_path__ + "static/media/notifications_bell.e8e0914d6098c0a5f940a484367ebd3f.svg";
export { ForwardRef as ReactComponent };